module.exports = __webpack_public_path__ + "img/tom.07f3bc8e.jpg";